import { useAlert } from 'react-alert';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  BtnModalTable,
} from '../../../styled-components';

const { REACT_APP_TAX_PERCENTAGE } = process.env;

const ModalSendEmail = (props) => {
  const [t] = useTranslation('CONTACTS');
  const { data: invoice, className = '', handleSendEmail = () => {} } = props;

  const [errors, setErrors] = useState({});
  const [modal, setModal] = useState(false);
  const alert = useAlert();

  const toggle = () => {
    setModal(!modal);
  };

  const onConfirm = () => {
    handleSendEmail(invoice._id);
    toggle();
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ marginLeft: '10px' }}>
          <BtnModalTable
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              toggle();
            }}
            disabled={invoice.paid === true ? true : false}
          >
            Invia Email
          </BtnModalTable>
        </div>
      </div>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {t('ROYALTY:MODAL_RECEIPT_INVOICE_TITLE')}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onConfirm();
          }}
        >
          <ModalBody>
            <div className="max-width-form">
              Sei sicuro di voler inviare un sollecito per questa fattura?
            </div>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default ModalSendEmail;
